module.exports = __webpack_public_path__ + "img/different-types-of-wigs.a3a16e32.png";